import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import ContactMenu from '../../components/menus/Contact';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import ContactForm from './ContactForm';
import MapSection from './MapSection';
import { colors } from '../../styles';


const styles = css`
  .ContactForm_wrapper {
    padding: 15px 20px 30px;
    @media (min-width: 768px) {
      padding: 30px 30px 60px;
    }
  }
  .ContactForm_wrapperInner {
    @media (min-width: 992px) {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .ContactForm_mapSection {
    padding: 58px 20px 70px;
    @media (min-width: 768px) {
      padding: 65px 30px 112px;
    }
  }
  .ContactForm_mapSectionInner {
    @media (min-width: 768px) {
      display: flex;
    }
    @media (min-width: 992px) {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .ContactForm_map {
    height: 263px;
    width: 100%;
    .leaflet-container {
      z-index: 0;
    }
    @media (min-width: 768px) {
      width: 64.933333%;
      flex-shrink: 0;
    }
  }
  .ContactForm_textWrapper {
    display: flex;
    justify-content: center;
    background-color: ${colors.color1};
    padding: 16px 20px 24px;
    @media (min-width: 768px) {
      width: 100%;
      justify-content: normal;
      align-items: center;
      padding: 0 34px;
    }
  }
  .ContactForm_address {
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0.0475em;
    line-height: 1.2;
    text-align: center;
    color: #B3B3B3;
    margin: 0;
    @media (min-width: 768px) {
      text-align: left;
    }
  }
  .ContactForm_address strong {
    display: block;
    font-size: 13px;
    margin-top: 6px;
  }
  .ContactForm_builderName {
    font-size: 17px;
    font-weight: bold;
    background-color: ${colors.color1};
    margin-bottom: 3px;
  }
`;


function ContactUs({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper className={styles}>
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <ContactMenu />
      <ContentBanner
        title={get(welcome, 'title')}
        lead={get(welcome, 'lead_copy')}
        image={get(welcome, 'image.contentUrl')}
        video={get(welcome, 'video')}
      />
      <section className="ContactForm_wrapper">
        <div className="ContactForm_wrapperInner">
          <ContactForm noRedirect />
          <MapSection page={page} />
        </div>
      </section>
    </PageWrapper>
  );
}

ContactUs.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'contact_us',
})(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js